import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { ISearchFilter } from '@app/core/services/search/resource-search/search-query-types.service';
import { SearchQueryService } from '@app/core/services/search/resource-search/search-query.service';
import { RunSearchColumnFields } from '../gridOptions/run-search-grid-options-formatter';
import { ISearchDataSourceOptions, SearchDataSource } from './search.datasource';

export class RunSearchDataSource extends SearchDataSource {
    constructor(
        searchQueryService: SearchQueryService,
        resourceDictionaryService: SearchResourceDictionaryService,
        dataSourceOptions: ISearchDataSourceOptions
    ) {
        const runResourceDictionary = resourceDictionaryService.getResourceConfigByType(SearchResourceType.Run);
        super(searchQueryService, runResourceDictionary, dataSourceOptions);

        const filterMethods: {[field: string]: (field: string, filterObj: any) => ISearchFilter} = {
            AggregateRunStatus: (field, filterObj) => {
                return {
                    facets: ['Status'],
                    currentChoice: {
                        value: filterObj.value,
                        label: null,
                    }
                }
            },
            Instrument: (field, filterObj) => {
                
                return {
                    facets: ['Instrument.SerialNumber'],
                    currentChoice: {
// We need to wrap the value in quotes so that we only get back exact matches. If we don't wrap the value in quotes
// you can get partial matches. eg MiSeq-Test will return any documents that have instruments with the word "Miseq" or
// "Test" in the instrument name
                        value: `"${filterObj.value}"`,
                        label: null,
                    }
                }
            },
        };

        this.filterMethods = filterMethods as any;
    }

    get rawTextFilterColumnName(): string {
        return RunSearchColumnFields.Name;
    }
}